import { ACTION_DETAILS } from "models/role/action";
import { SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS } from "models/role/subject";
import { lazyRetryWithPreload } from "utils/lazyRetryWithPreload";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Payments = lazyRetryWithPreload(
  () => import("../pages/Payments"),
  "Payments"
);

const PaymentDetails = lazyRetryWithPreload(
  () => import("../pages/PaymentDetails"),
  "PaymentDetails"
);

export const accountsPaymentsRoutes: Route[] = [
  {
    path: PAGE_URLS.payments,
    component: Payments,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
  {
    path: PAGE_URLS.paymentDetails,
    component: PaymentDetails,
    showChildrenInSidebar: false,
    can: {
      do: ACTION_DETAILS,
      on: SUBJECT_CASH_MANAGEMENT_VOLT_ACCOUNTS,
    },
  },
];
